module.exports = __webpack_public_path__ + "img/caret-up-fill.9058353c.svg";